import { render, staticRenderFns } from "./BetaFeatures.vue?vue&type=template&id=36d30510"
import script from "./BetaFeatures.vue?vue&type=script&lang=js"
export * from "./BetaFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports